import functions from '../../functions';

import { destinationCard, siblingsCard, sidebarCard } from './static-components';


if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { RawHTML } = window.wp.element;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        CheckboxControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/subpages', {
        // built-in attributes
        title: 'Subpages',
        description: 'subpages',
        icon: '',
        category: 'custom-containers',
        example: {},

        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            btnText: {
                type: 'string',
                default: ''
            },
            cards: {
                type: 'boolean',
                default: false
            },
            sidebar: {
                type: 'boolean',
                default: false
            },
            postId: {
                type: 'string',
                default: '',
            },
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                link,
                btnText,
                cards,
                sidebar,
                postId,
                classes
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            let useSiblingsTemplate = postId && ! cards;
            let useSibebarTemplate = sidebar;
            
            return (
                [<InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody>
                        <p><strong>Url</strong></p>
                        <TextControl value={ link } onChange={link => setAttributes({ link })}></TextControl>
                        <p><strong>Btn text</strong></p>
                        <TextControl value={ btnText } onChange={btnText => setAttributes({ btnText })}></TextControl>
                        <p><strong>Parent post id</strong></p>
                        <TextControl value={ postId } onChange={ postId => setAttributes({ postId }) }></TextControl>
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Cards"
                            checked={ cards }
                            onChange={ cards => setAttributes({ cards })}
                        />
                        <CheckboxControl
                            __nextHasNoMarginBottom
                            label="Sidebar"
                            checked={ sidebar }
                            onChange={ sidebar => setAttributes({ sidebar })}
                        />
                    </PanelBody>
                </InspectorControls>,
                <div class="subpages">
                    <RawHTML className="row g-3">
                        { useSibebarTemplate ? '<div class="sidebar-siblings">' + sidebarCard.repeat(4) + '</div>' : (useSiblingsTemplate ? siblingsCard.repeat(8) : (destinationCard.repeat(8) +( (link && btnText) ? `<div class="card destination-card last" href>
                            <div class="card-content">
                                    <div class="title">
                                        ` + btnText + ` <i class="las la-angle-right"></i>
                                    </div>
                            </div>
                        </div>` : ``))) }
                        
                    </RawHTML>
                </div>    
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                btnText,
                postId,
                sidebar,
                cards
            } = attributes;

            return (
                <div>
                    [get_wp_subpages url="{link}" btnText="{btnText}" cards={cards && 'true'} post_parent="{postId}" sidebar="{sidebar && 'true'}"]
                </div>
            );
        },
    });
}